import React from 'react';

const recentBookingTupleHeader = () => (
    <div className={`pl-5 pr-7 pt-5 pb-5 phone-p-2 u-flex phone-justify-content-between u-textUppercase u-phoneHide`}>
        <div>
            <span className={`u-fontSize11 u-fontWeightRegular u-textColorNormal u-letterSpacing05`}>YT Number</span>
        </div>
        <div className={`u-width120 u-phone-widthAuto ml-8Pt5Per phone-ml-0`}>
            <span className={`u-fontSize11 u-fontWeightRegular u-textColorNormal u-letterSpacing05 `}>Passenger Name</span>
        </div>
        <div className={`u-width120 u-phone-widthAuto ml-8Pt5Per phone-ml-0`}>
            <span className={`u-fontSize11 u-fontWeightRegular u-textColorNormal u-letterSpacing05`}>Sector</span>
        </div>
        <div className={`u-width120 u-phone-widthAuto ml-8Pt5Per phone-ml-0`}>
            <span className={`u-fontSize11 u-fontWeightRegular u-textColorNormal u-letterSpacing05`}>Date</span>
        </div>
        <div className={`ml-auto`}>
            <span className={`u-fontSize11 u-fontWeightRegular u-textColorNormal u-letterSpacing05`}>Action(s)</span>
        </div>
    </div>
);

export default recentBookingTupleHeader;


// WEBPACK FOOTER //
// ./src/components/RecentBooking/RecentBookingTupleHeader/RecentBookingTupleHeader.js